<template lang="pug">
div
  v-container.pa-0(@click="viewExpense()")
    v-row.align-center.ma-0.px-4.py-1(
      style="background-color: var(--v-basic600T08)",
      v-if="isFirstDate"
    )
      v-col.ma-0.pa-0
        .s2.primary400--text {{ getMonth(expense.record_date) }}
    v-row.align-center.ma-0.px-4.py-3.border-bottom
      v-col.ma-0.pa-0(cols="8" md="9")
        .s1.basic800--text {{ shortDescription }}
        .c1.basic600--text.d-inline-flex
          | {{ getShortDate(expense.record_date) }}
          span.mx-1(style="font-size: 3px !important") ●
          .text-capitalize {{ textLimit(expense.category.name, 30) }}
      v-col.ma-0.pa-0.text-end(cols="4" md="3")
        .s1(
          :class="getStatus() == 'overdue' ? 'danger500--text' : ''"
        ) {{ expense.amount | displayPrice }}
        .c1.danger500--text.text-capitalize(
          v-if="getStatus() == 'overdue'"
        ) {{ getStatus() }}
        .c1.success500--text.text-capitalize(
          v-if="getStatus() == 'settled'"
        ) {{ getStatus() }}
        .c1.primary400--text(
          v-if="getStatus() == 'not_yet_due'"
        ) Not yet due
  .actionSheet
    y-bottom-sheet(v-model="actionSheet", inset, scrollable, max-width="600px")
      v-card(flat)
        v-card-title.px-4.py-3(
          :style="'background-color:var(--v-' + getColor(getStatus(), 'T') + ')'"
        )
          v-row
            v-col
              .s1.primary500--text {{ expense.category.name }}
              .c1(:class="getColor(getStatus(), 'S') + '--text'")
                span(v-if="getStatus() == 'not_yet_due'") Not yet due
                span.text-capitalize(v-else) {{ getStatus() }}
            v-col.shrink.px-0
              v-menu(left, offset-y)
                template(v-slot:activator="{ on }")
                  v-btn.mr-1(
                    text,
                    icon,
                    min-width="auto",
                    :ripple="false",
                    v-on="on"
                  )
                    eva-icon(
                      name="more-vertical",
                      :fill="$vuetify.theme.themes[$theme].primary500",
                      height="25",
                      width="25"
                    )
                v-list(dense)
                  v-list-item(v-if="payments.length > 0 && getStatus() != 'settled'" @click="openPaymentListDialog = true")
                    v-list-item-content
                      v-list-item-title.s2.basic800--text Edit payment history
                  v-list-item(@click="clickDelete()")
                    v-list-item-content
                      v-list-item-title.s2.basic800--text Delete
        v-card-text.px-4.pb-3
          v-row.border-bottom.py-1
            v-col
              .p2.primary400--text {{ expense.vendor.name }}
              .p2.primary400--text {{ expense.notes }}
            v-col.text-end(cols="4")
              .p2.primary400--text {{ expense.record_date | displayDate }}
          v-row.border-bottom.py-1(v-if="expense.items.length > 1")
            v-row.mx-1(v-for="(item,index) in expense.items" :key="index" style="width:100%")
              v-col.px-2.py-1
                .p2.primary500--text.text-capitalize {{item.description}}
              v-col.text-end.px-2.py-1(cols="4")
                .p2.primary500--text.text-capitalize {{item.amount | displayPrice}}
          v-row.border-bottom.py-1(v-if="getStatus() != 'settled'")
            v-col
              .p2(
                :class="getStatus() == 'overdue' ? 'danger500--text' : 'primary400--text'"
              ) Due: {{ expense.due_at ? expense.due_at : '' | displayDate }}
            v-col.shrink.px-2
              v-btn.elevation-0.pa-0(
                text,
                color="transparent",
                :ripple="false",
                x-small,
                light,
                @click="showScheduleReminderDialog = true",
              )
                eva-icon(
                  name="calendar-outline",
                  :fill="$vuetify.theme.themes[$theme].info500",
                  height="15"
                )
                .button-Aa-small.info500--text.text-capitalize Remind me
          div.border-bottom.py-1(v-if="payments.length > 0")
            .p2.primary400--text.py-1.mt-1 Payment history
            .showMoreList
              v-row.pt-1(v-for="(payment, index) in listToShow" v-if="index < payments.length" :key="index" no-gutters)
                v-col 
                  .p2.primary500--text.d-inline-flex
                    | {{ payments[index].paid_date | displayDate }}
                    span.mx-1(style="font-size: 3px !important") ●
                    | {{ payments[index].payment_method }}
                v-col.text-end
                  .c1.basic600--text.d-inline-flex
                    | {{ payments[index].amount | displayPrice }}
              div.text-center(v-if="listToShow < payments.length || payments.length > listToShow")
                  v-btn.ma-2(@click="listToShow+=3" text,
                  color="transparent",
                  :ripple="false",
                  x-small,
                  light,)
                    .button-Aa-small.info500--text.text-capitalize Show More
              div.text-center(v-if="payments.length > 3 && listToShow >= payments.length && payments.length > 1")
                  v-btn.ma-2(@click="listToShow=3" text,
                  color="transparent",
                  :ripple="false",
                  x-small,
                  light,)
                    .button-Aa-small.info500--text.text-capitalize Show Less
          div.border-bottom.py-1
            .product-image.d-flex.my-2
              .s2.primary500--text.my-auto Attachments
              v-spacer
              v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="addMoreImagesDialog = true")
                v-icon.mr-1(small) mdi-plus
                | Add image
            v-row.ma-1.mx-0(v-if="documents.length > 0")
              v-col(v-for='(document, index) in documents' cols="2" style="padding: 1px" :key="document.document.hid")
                v-card.pa-1(flat tile @click="viewAttachments(index)")
                  v-img(:src="document.document.file " aspect-ratio="1")
                    template(v-slot:placeholder)
                      v-row(class="fill-height ma-0" align="center" justify="center")
                        v-progress-circular(indeterminate color="grey")

          v-row.py-1
            v-col
              .s2.primary500--text(:class="(getStatus() == 'overdue' && expense.amount_remaining == expense.amount)? 'danger500--text' : ''") Total {{ !expense.paid ? 'amount due' : ''}}
              .p2(v-if="!expense.paid && expense.amount_remaining != expense.amount" :class="getStatus() == 'overdue'? 'danger500--text' : 'basic600--text'") Balance due
            v-col.text-end
              .s2.primary500--text(:class="(getStatus() == 'overdue' && expense.amount_remaining == expense.amount)? 'danger500--text' : ''") {{ expense.amount | displayPrice }}
              .p2(v-if="!expense.paid && expense.amount_remaining != expense.amount" :class="getStatus() == 'overdue'? 'danger500--text' : 'basic600--text'") {{ expense.amount_remaining | displayPrice  }}
        v-card-actions(v-if="getStatus() != 'settled'")
          v-row
            v-col.py-1.mx-2
              v-btn(
                depressed,
                color="info500",
                height="40",
                @click="clickRecordPayment",
                style="background-color: var(--v-infoT08)"
                block
              ) 
                .button-AA-small.basic100--text update payment

  .modals
    send-reminder(v-if="showSendReminderDialog" :open.sync="showSendReminderDialog" :selectedInvoices="selectedInvoices")
    schedule-reminder(v-if="showScheduleReminderDialog" :open.sync="showScheduleReminderDialog" :selectedInvoices="selectedInvoices"  type="expense")
    RecordPayment(v-if="showRecordPaymentDialog" :open.sync="showRecordPaymentDialog" :parentExpense.sync="expense" @payment-added="handlePaymentAdded" @document-added="handleDocumentAdded")
    PaymentList(v-if="openPaymentListDialog" :open.sync="openPaymentListDialog" :payments.sync="payments" :parentExpense.sync="expense" @edited="handleEditItem")
    PhotoGallery(v-if="openPhotoGalleryDialog" :open.sync="openPhotoGalleryDialog" :photos="galleryPhotos" :index.sync="currentPhotoIndex")
    ManageDocuments(v-if="addMoreImagesDialog" :open.sync="addMoreImagesDialog" :expenseId="expense.id" @updated="handleUpdateDocuments")
    y-dialog(v-model="openDeleteDialog", max-width="290", persistent)
      v-card
        v-card-title.h6.basic800--text.px-4 Delete expense
        v-card-text.p2.primary500--text.px-4
          | Are you sure you want to delete this item? This item will be deleted permanently.
        v-card-actions
          v-spacer
          v-btn(color="white", text, @click="openDeleteDialog = false")
            .button-Aa-small.primary400--text Cancel
          v-btn(
            color="danger500",
            depressed,
            dark,
            @click="startDelete",
            :loading="isLoading"
          )
            .button-AA-small.basic100--text Delete

</template>
<script>
import { mapGetters, mapActions } from "vuex"
import { DateTime } from 'luxon'
import SendReminder from '@/components/yezzabook/dialogs/SendReminder.vue'
import ScheduleReminder from '@/components/yezzabook/dialogs/ScheduleReminder.vue'
import RecordPayment from '@/components/yezzabook/dialogs/expense/RecordPayment.vue'
import PaymentList from '@/components/yezzabook/dialogs/expense/PaymentList.vue'
import PhotoGallery from '@/components/PhotoGallery'
import ManageDocuments from '@/components/yezzabook/dialogs/expense/ManageDocuments.vue'

export default {
  name: "ExpenseItem",
  props: ["parentExpense", "isFirstDate"],
  components: { SendReminder, ScheduleReminder, RecordPayment, PaymentList, PhotoGallery, ManageDocuments },
  data: () => ({
    openInvoiceDialog: false,
    openPaymentListDialog: false,
    addMoreImagesDialog: false,
    openingLead: null,
    actionSheet: false,
    listToShow: 3,
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    openDeleteDialog: false,
    isLoading: false,
    selectedInvoices: [],
    showScheduleReminderDialog: false,
    showSendReminderDialog: false,
    showRecordPaymentDialog: false,
    payments: [],
    documents: [],
    openPhotoGalleryDialog: false,
    currentPhotoIndex: 0
  }),
  computed: {
    ...mapGetters({
      company: "getCompany",
    }),
    expense: {
      get() {
        return this.parentExpense
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    shortDescription (){
      const categories = this.expense.items
      const length = categories.length;
      if (length == 0) {
        return 'Null Description'
      } else{
        if (length == 1) {
          return this.textLimit(categories[0].description, 30);
        }else{
          var more =  length - 1;
          return this.textLimit(categories[0].description, 20) + " +" + more + " more";
        }
      }
    },
    galleryPhotos () {
      if (this.documents.length == 0) {
        return []
      }
      return this.documents.map(document => { return { url: document.document.file } })
    }
  },
  mounted (){
    this.selectedInvoices.push(this.parentExpense)
  },
  methods: {
    ...mapActions(["showMessage"]),
    getMonth(val) {
      const date = DateTime.fromISO(val)
      return date.monthLong + " " + date.year
    },
    getShortDate(val) {
      const date = DateTime.fromISO(val)
      return date.day + " " + date.monthShort
    },
    getColor(val, type) {
      var color;
      if (val == "overdue" && type == "T") {
        color = "dangerT08";
      } else if (val == "settled" && type == "T") {
        color = "successT08";
      } else if ((val == "sent" || val == "not_yet_due") && type == "T") {
        color = "basic600T08";
      } else if ((val == "sent" || val == "not_yet_due") && type == "S") {
        color = "primary400";
      } else if (val == "settled" && type == "S") {
        color = "success500";
      } else if (val == "overdue" && type == "S") {
        color = "danger500";
      }
      return color;
    },
    getTitle(val) {
      if (val == "settled") {
        return "Receipt";
      } else if (val == "quotation") {
        return "Quotation";
      } else {
        return "Invoice";
      }
    },
    getStatus() {
      const stat = this.expense.payment_status
      const dueString = this.expense.due_at ? this.expense.due_at : ''
      const sent = this.expense.reminder_sent
      if (stat == 'paid') {
        return "settled";
      } else if (sent) {
        return "sent";
      } else {
        if (dueString) {
          const currentDate = DateTime.local()
          const duedate = DateTime.fromFormat(dueString, 'yyyy-MM-dd')
          if (!this.expense.paid && currentDate.startOf("day") > duedate.startOf("day")) {
            return "overdue";
          } else {
            return "not_yet_due";
          }
        } else {
          return "not_yet_due";
        }
      }
    },
    textLimit(text,max){
      if (text.length > max && this.$vuetify.breakpoint.width < 411 && this.$vuetify.breakpoint.width > 330) {
        return `${text.substring(0, max - 1)}...`
      }else if (text.length > max && this.$vuetify.breakpoint.width < 340) {
        return `${text.substring(0, max - 6)}...`
      }
      return text
    },
    fetchPayments () {
      this.$axios.get(`/books/${this.company.slug}/expenses/${this.expense.id}/payments?ordering=-id`)
        .then((response) => {
          this.payments = response.data.results
        })
        .catch(() => {})
    },
    fetchDocuments () {
      this.$axios.get(`/books/${this.company.slug}/expenses/${this.expense.id}/documents?ordering=-id`)
        .then((response) => {
          this.documents = response.data.results
        })
        .catch(() => {})
    },
    handleUpdateDocuments () {
      this.fetchDocuments()
    },
    viewExpense () {
      if (this.payments.length === 0 && this.expense.amount_remaining != this.expense.amount) {
        this.fetchPayments()
      }
      if (this.documents.length === 0 && this.expense.amount_remaining != this.expense.amount) {
        this.fetchDocuments()
      }
      this.actionSheet = true
    },
    viewAttachments (index) {
      this.currentPhotoIndex = index
      this.openPhotoGalleryDialog = true
    },
    clickDelete() {
      this.openDeleteDialog = true;
    },
    startDelete() {
      this.isLoading = true;
      this.axios
        .delete(`/books/${this.company.slug}/expenses/${this.expense.id}/`)
        .then(() => {
          this.$emit("deleted", this.expense);
          this.openDeleteDialog = false
          this.actionSheet = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    clickRecordPayment () {
      this.showRecordPaymentDialog = true
    },
    handlePaymentAdded (item) {
      this.payments.splice(0, 0, item)
    },
    handleDocumentAdded (item) {
      this.documents.splice(0, 0, item)
    },
    handleEditItem (item) {
      let editIndex = 0
      this.payments.forEach((payment, index) => {
        if (payment.id === item.id) {
          editIndex = index
        }
      })
      this.payments = this.payments.filter((x) => x.id !== item.id)
      this.payments.splice(editIndex, 0, item)
    }
  },
};
</script>
<style scoped>
.border-bottom {
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>